export default "MaPrimeRénov’ Copropriété 2026 — Travaux collectifs et aides Anah | Solution Éco France";
